import { CheckCircle2, CircleSlash, Loader, TriangleAlert } from 'lucide-react'
import type { ReactNode } from 'react'

import { StatusMessage } from '@krp/ui-kit'

import type { ShareVm, StateBadgeVm, TestingAccess } from '../model/types'
import './testing.css'

const BADGE_ICONS: Record<StateBadgeVm['tone'], ReactNode> = {
  ok: <CheckCircle2 size={16} aria-hidden="true" />,
  busy: <Loader size={16} aria-hidden="true" />,
  bad: <TriangleAlert size={16} aria-hidden="true" />,
  muted: <CircleSlash size={16} aria-hidden="true" />,
}

/** Состояние значком и словами: цвет только дублирует их (CLAUDE.md §7). */
export function StateBadge({ badge }: { badge: StateBadgeVm }) {
  return (
    <span className="platform-testing__badge" data-tone={badge.tone}>
      {BADGE_ICONS[badge.tone]} {badge.text}
    </span>
  )
}

/** Балл всегда с числом кадров и интервалом: «72 %» без «n = 3» обманывает. */
export function Share({ share }: { share: ShareVm }) {
  return (
    <span className="platform-testing__share">
      <strong>{share.value}</strong> <small>{share.detail}</small>
    </span>
  )
}

/**
 * Вкладка открывается только с правом замеров. Пункта меню без права нет, а
 * прямой адрес показывает «нет доступа» — сервер всё равно ответил бы 403.
 */
export function TestingGate({ access, children }: { access: TestingAccess; children: ReactNode }) {
  if (access === 'unknown') return <StatusMessage kind="loading" title="Загрузка…" />
  if (access === 'denied') {
    return (
      <StatusMessage
        kind="forbidden"
        title="Нет доступа"
        text="Тестирование поиска открыто администраторам и тем, кому администратор выдал право на замеры"
      />
    )
  }
  return <>{children}</>
}
